// Den valgte ansattes åpne ordrer (GET /orders/mine-aktive), med alder i virkedager regnet på
// serveren (src/lib/virkedager.js, helligdager med). Brukes av «Ordrer» på kontrollpanelet,
// «Dine aktive ordrer» på /ordre og varselet når en ansatt logger inn (UbehandledeOrdrer.jsx).

import { leggTilVirkedager } from '../lib/virkedager';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Varseltrekant på kontrollpanelet og ordrene: eldre enn 7 virkedager.
export const GAMMEL_ETTER = 7;
// Varsel ved innlogging: 10 virkedager eller eldre uten å være avsluttet.
export const UBEHANDLET_FRA = 10;

// «Utsett varsel» på ordren: standard 5 virkedager fram (UtsettOrdreVarsel.jsx), med helligdager
// som på serveren (src/lib/virkedager.js).
export const UTSETT_STANDARD_VIRKEDAGER = 5;
export const standardUtsettDato = () => leggTilVirkedager(iDagNorge(), UTSETT_STANDARD_VIRKEDAGER);

// Varselet gjelder ikke ordre der det er utsatt (`utsatt` regnes på serveren).
export const erGammel = (ordre) => !ordre.utsatt && (ordre.virkedager ?? 0) > GAMMEL_ETTER;
export const erUbehandlet = (ordre) => !ordre.utsatt && (ordre.virkedager ?? 0) >= UBEHANDLET_FRA;

// Gir lista (eldste først), eller null hvis den ikke kunne hentes.
export async function hentMineOrdrer(ansatt) {
  if (!ansatt) return [];
  try {
    const r = await fetch(`${API_BASE_URL}/orders/mine-aktive?ansatt=${encodeURIComponent(ansatt)}&t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    return (await r.json()).ordrer || [];
  } catch (e) {
    return null;
  }
}

export const virkedagerTekst = (n) => `${n} ${n === 1 ? 'virkedag' : 'virkedager'}`;

// Datoer som "YYYY-MM-DD" i norsk tid, som på serveren.
export const iDagNorge = () => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Oslo' }).format(new Date());
export const datoOmDager = (n, fra = iDagNorge()) =>
  new Date(Date.parse(`${fra}T00:00:00Z`) + n * 864e5).toISOString().slice(0, 10);

// "2026-11-01" → "søn. 1.11.2026"
export const visDato = (iso) => {
  const d = new Date(`${iso}T00:00:00Z`);
  const ukedag = new Intl.DateTimeFormat('nb-NO', { weekday: 'short', timeZone: 'UTC' }).format(d);
  return `${ukedag} ${d.getUTCDate()}.${d.getUTCMonth() + 1}.${d.getUTCFullYear()}`;
};
